var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.currentIcon)?_c('div',{style:([{ height: _vm.size }, { width: _vm.size }]),attrs:{"title":_vm.tag},domProps:{"innerHTML":_vm._s(_vm.currentIcon)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }